<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
      </v-overlay>
      <v-row class="pa-2" no-gutters>
        <custom-popup
          v-model="ready"
          :cons="{ title: $t('sample_menu') }"
          hide-confirm
          hide-overlay
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-sample-menu-d`"
              :help-data="helpData"
              :service-name="serviceName"
              :label="$t('sample_menu')"
              class="buttoninfo"
            />
          </template>
          <v-card class="p-5" flat>
            <prepared-cards
              :value="cardTexts"
              type="menu"
              @closeModel="ready = false"
              @input="savePageTemplate"
            />
          </v-card>
        </custom-popup>

        <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
          <v-tabs
            v-model="qrShow"
            background-color="grey lighten-3 pa-1"
            class="rounded-pill mx-auto pa-1"
            color="primary"
            height="48"
            style="width: fit-content"
          >
            <v-tab :disabled="e6 <= 1"> {{ $t("view_qr") }}</v-tab>

            <v-tab> {{ $t("preview") }}</v-tab>
          <v-tab :disabled="e6 <= 1" :ripple="true"> تعرفه‌ها </v-tab>

          </v-tabs>
        </v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 110px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <v-tab-item >
              <div class="d-flex flex-column justify-center align-center">
                <qr-maker :loading="loading" />
                <v-btn class="btn-download" @click="showDialog = true">
                  <v-icon>mdi-progress-download</v-icon>
                {{ $t("download_qr") }}
                </v-btn>
              </div>
            </v-tab-item>

            <v-tab-item>
              <div class="sticky-preview" style="position: relative; min-height: 100%;">
                <view-menu v-model="cardTexts" :qr-svg-data-url="qrSvgDataUrl"/>
              </div>
            </v-tab-item>
            <v-tab-item v-if="!!info?.id && e6>1">
                <Tariffs :id_qr="info.id" :qrtype="'menu'" />
             </v-tab-item>

          </v-tabs-items>
        </v-col>

        <v-col class="pa-2 px-0" cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-12">
                  <p>{{ $t("create_qr") }}</p>
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <v-text-field
                    v-model="cardTexts.visitName"
                    :disabled="e6 > 2"
                    :error-messages="errors.title"
                    :label="$t('online_menu_name')"
                    append-icon="mdi-pen"
                    class="mt-0 pt-0 contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-visitName`"
                    :help-data="helpData"
                    :label="$t('online_menu_name_short')"
                    :service-name="serviceName"
                    class="buttoninfo"
                  />
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <qr-address-field
                    id="qr-address"
                    ref="address-field"
                    v-model="dtUrl"
                    :disabled="e6 > 2"
                    :error-messages="errors.identifier"
                    :key="$t('qrAddressUpdate.hints.allowedChars')"
                    :hint="$t('qrAddressUpdate.hints.allowedChars')"
                    append-icon="mdi-web"
                    class="mt-0 pt-0 contentinfo"
                    dense
                    outlined
                    persistent-hint
                    @updateDest="domainId = $event"
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-dtUrl`"
                    :help-data="helpData"
                    :label="$t('qr_address')"
                    :service-name="serviceName"
                    class="buttoninfo"
                  />
                </div>
              </div>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="markQr(false)"
                />
              </div>
            </v-stepper-content>

            <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2"
              >{{ $t("enter_menu_information") }}
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
              <v-card-actions class="justify-space-between mb-4">
                <div>
                  <div class="d-flex row mx-0 mt-2">
                    <v-btn
                      :disabled="e6 > 2"
                      color="third"
                      outlined
                      @click="clearDefaults"
                    >
                      <v-icon class="me-2">mdi-delete</v-icon>
                      {{ $t("buttons.cleardefaults") }}
                    </v-btn>
                    <help-info
                      :element-name="`${serviceName}-${componentName}-clearDefaults`"
                      :help-data="helpData"
                      :label="$t('buttons.cleardefaults')"
                      :service-name="serviceName"
                    />
                    <v-btn
                      class="ma-0 btn-download"
                      depressed
                      @click="ready = true"
                    >
                      {{ $t("select_sample_menu") }}
                    </v-btn>
                    <help-info
                      :element-name="`${serviceName}-${componentName}-preparedData`"
                      :help-data="helpData"
                      :label="$t('select_ready_menu')"
                      :service-name="serviceName"
                    />
                  </div>
                </div>

                <v-switch
                  v-model="cardTexts.product.onlineShop"
                  :label="$t('online_sales')"
                  class="ma-0"
                  dense
                  hide-details
                  inset
                />
              </v-card-actions>
              <div class="mb-4 mx-4">
                    <div class="d-flex align-center">
                      <v-switch
                        v-model="AutoSave"
                        color="primary"
                        class="mt-0 pt-0 shrink"
                        hide-details
                        label="ذخیره خودکار"
                      ></v-switch>
                      <v-tooltip bottom max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            x-small
                            class="mr-1"
                            v-bind="attrs"
                            v-on="on"
                            @click.stop
                          >
                            <v-icon small color="grey darken-1">
                              mdi-help-circle-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>
                          تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                        </span>
                      </v-tooltip>
                    </div>
                    <div
                      v-if="$vuetify.breakpoint.xsOnly"
                      class="text-caption grey--text text--darken-1 mt-1 pr-1"
                      style="line-height: 1.4"
                    >
                      تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                    </div>
              </div>

              <list-expansion
                v-model="cardTexts"
                :component-name="componentName"
                :components="specialInfo"
                :data="cardTexts"
                :service-name="serviceName"
                flat
                @save-required="AutoSave && qrUpdate(false)"
              />

              <div class="row mx-auto">
                <div class="col-md-6">
                  <prev-btn :loading="loading" @click="e6 = 1" />
                </div>

                <div class="col-md-6">
                  <next-btn :loading="loading" @click="qrUpdate(true);
                  if(!cardTexts?.product?.onlineShop)
                      goTo('qr/list')" />
                </div>
              </div>
            </v-stepper-content>

            <v-stepper-step
              v-if="cardTexts?.product?.onlineShop"
              :complete="e6 > 3"
              class="px-0 px-md-4"
              step="3"
            >
              {{ $t("sales_settings") }}
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="3">
              <qr-shop-manager ref="qrShop" :qr-id="createdId"
                              @save-required="AutoSave && qrUpdate(false)" />

              <div class="row mx-auto">
                <div class="col-md-6">
                  <prev-btn :loading="loading" @click="e6 = 2" />
                </div>

                <div class="col-md-6">
                  <next-btn :loading="loading" @click="updateShopSettings" />
                </div>
              </div>
            </v-stepper-content>
          </v-stepper>

          <div class="d-none">
            <qr-code-make
              ref="qrCanvas"
              v-model="qrDesign"
              :file.sync="qrSvgDataUrl"
              :link="fullLink"
              @save="qrDesign = $event"
            />
          </div>
        </v-col>

        <custom-popup
          v-model="showDialog"
          :cons="{ title: $t('download_qr') }"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-show-download-d`"
              :help-data="helpData"
              :label="$t('download_qr')"
              :service-name="serviceName"
              class="buttoninfo"
            />
          </template>
          <v-card class="pa-5">
            <div class="rowinfo">
              <download-file-with-api
                v-if="showDialog"
                :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
                :visit-name="cardTexts.visitName"
                class="contentinfo"
                @close="showDialog = false"
                :qr_id="info.qrId"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-cardTexts-visitName`"
                :help-data="helpData"
                :label="$t('download')"
                :service-name="serviceName"
                class="buttoninfo"
              />
            </div>
          </v-card>
        </custom-popup>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import Tariffs from "../../../components/Tariffs/Tariffs.vue";
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import ViewMenu from "./cm/viewMenu.vue";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import { Bus } from "@/main";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import PrevBtn from "@/view/content/fragments/prevBtn";
import DownloadFileWithApi from "@/view/pages/qrland/downloadFileWithApi";
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import PreparedCards from "@/view/pages/qrland/preparedCards";
import QrCodeMake from "../../qrland/qrCodeStyle/qrCodeMake";
import { mapActions, mapState } from "vuex";
import QrShopManager from "@/view/pages/qrland/components/qrManage/manageShop/qrShopManager.vue";
import StoreShopContent from "@/utilities/StoreShopContent";
import { getLanguageCookie } from "../../../../core/plugins/TitleRibbon/utils/languageCookie";
import { AtomSpinner } from "epic-spinners";
import goTo from "vuetify/lib/services/goto";

export default {
  name: "create",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    QrShopManager,
    QrCodeMake,
    PreparedCards,
    QrCustomize,
    DownloadFileWithApi,
    PrevBtn,
    QrManagement,
    NextBtn,
    ListExpansion,
    QrAddressField,
    ViewMenu,
    QrMaker,
    Tariffs,
    AtomSpinner
  },

 provide() {
    return {
      productImageSize: "128",
      getMenuCurrency: () => this.selectedCurrency
  }
},
  data: () => ({
    isAutoSaving: false, 
    AutoSave:false,
    selectedCurrency: 'ریال',
    helpData: [],
    serviceName: "Qrland",
    componentName: "menu-create",
    cardTexts: {},
    createdDomain: null,
    createdId: null,
    domainId: null,
    dtUrl: null,
    errors: {},
    e6: 1,
    info: null,
    showDialog: false,
    ready: false,
    loading: false,
    qrShow: 1,
    qrDesign: {},
    qrSvgDataUrl: "",
  }),

  created() {
     this.cardTexts = this.getInitialCardTexts();
  },

  mounted() {
    Bus.$on("socialMedias", (value) => {
      this.cardTexts.socialMedia = value;
    });
    // this.cardTexts = this.getInitialCardTexts();
    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;
  },

  computed: {
    ...mapState("localstorage", ["createQrID"]),
    fullLink() {
      return this.createdDomain?.replace("/", "") + "/" + this.createdId;
    },
    
    specialInfo() {
      return [
         {
        name: "ThemeSelector2",
        value: "",
        title: this.$t('select_template_design'),
        subtitle: "",
        icon: "card-account-details-star-outline",
        model: "ThemeSelector2"
      
      },
         {
          name: "shopLoginConfig",
          value: "",
          title: this.$t("shop.login_settings"),
          subtitle: "",
          icon: "home-import-outline",
          model: "shopLoginConfig",
          tabs: [
            {
              title: this.$t("shop.store_logo_images"),
              icon: "mdi-cards-playing-heart-outline",
              component: "shopLogo",
              model: "shopLogo",
            },
            {
              title: this.$t("shop.login_page_info"),
              icon: "mdi-view-carousel-outline",
              component: "shopLoginConfig",
              model: "configs",
            },
          ],
        },
        {
        name: "GeneralSettings",
        value: "",
        title: this.$t('general_menu_settings'),
        subtitle: "",
        icon: "cog-outline",
        model: "settings"
      
      },
        {
          name: "bannerSelector",
          value: "",
          title: this.$t("shop.upload_banner"),
          subtitle: "",
          icon: "image-area",
          model: "banner",
        },
        {
          name: "Product",
          value: "",
          title: this.$t("shop.create_product"),
          subtitle: "",
          icon: "sign-yield",
          model: "product",
        },
        {
          name: "textCards",
          value: "",
          title: this.$t("shop.user_info"),
          subtitle: "",
          icon: "account-outline",
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: this.$t("shop.add_social_media"),
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
        },
        {
          name: "PicSelector",
          value: "",
          title: this.$t("shop.photo_gallery"),
          subtitle: "",
          icon: "image-outline",
        },
        {
          name: "VideoGallery",
          value: "",
          title: this.$t("shop.video_gallery"),
          subtitle: "",
          icon: "video-outline",
        },
        {
          name: "FeedBack",
          value: "",
          title: this.$t("shop.feedback"),
          subtitle: "",
          icon: "reply-outline",
          model: "FeedBack",
        },
        {
          name: "WorkSheet",
          value: "",
          title: this.$t("shop.working_hours"),
          subtitle: "",
          icon: "timetable",
          model: "WorkSheet",
        },
      ];
    },
  },

  watch: {
  "cardTexts.settings.currency": {
      handler(val) {
        if (!!val) {
          this.selectedCurrency = val;
        }
      },
      immediate: true, 
    },
        "$i18n.locale": {
      handler() {
         this.cardTexts = this.getInitialCardTexts();
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID", "setQrType"]),
    ...mapActions("local", [
      "updateQrId",
      "updateQridentifier",
      "updateQrInfo",
      "updateQrDomain",
    ]),
         getInitialCardTexts() {
           
          return {
            ThemeSelector2:{
              theme:'theme_1'
            },
          shopLoginConfig: {
            shopLogo: [
              {
              value: "logo",
              name: this.$t("background_image"),
              logo: "",
            },
            {
              value: "background",
              name: this.$t("background_image"),
              background: "",
            },            ],
            configs: { subtitle: "" },
          },
            settings: {
              showFilter: true,
              showCategories: true,
              currency: "ریال", 
                businessType: "restaurant", // 'restaurant' یا 'shop'
              customLabels: {
                productsTitle: "",
                cartButton: "",  
              }
            },
        banner: {
          gallery: [
            {
              name: this.$t("create_menu.photo_gallery_0"),
              images: [
                {
                  name: this.$t("create_menu.fast_food_1"),
                  title: "",
                  url: this.$cdnUrl + "/upload/65684636e1e0d.webp",
                  description: "",
                  link: "",
                  id: 15867,
                },
                {
                  name: this.$t("create_menu.fast_food_2"),
                  title: "",
                  url: this.$cdnUrl + "/upload/6568463b5c4cf.webp",
                  description: "",
                  link: "",
                  id: 15868,
                },
              ],
            },
          ],
        },
        product: {
          title: this.$t("create_menu.data.product.title"),
          description: "",
          sectionColor: {
            backGround: "",
            text: "#000",
          },
          items: [
            {
              name: this.$t("create_menu.data.product.pizzas"),
              picture: this.$cdnUrl + "/upload/65438ae3de594.webp",
              children: [],
              status: "active",
              source_id: null,
              products: [
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.pizza_roast_beef"),
                  description: this.$t(
                    "create_menu.data.product.pizza_roast_beef_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery: !this.IS_IR
                    ? '[{"name":"","images":[{"name":"پیتزا8","title":"","url":"https://cdn.terminalads.com/upload/65438ae89c5de.webp","description":"","link":"","id":15046}]}]'
                    : '[{"name":"","images":[{"name":"پیتزا8","title":"","url":"https://cdn.terminalads.com/upload/65438ae89c5de.webp","description":"","link":"","id":15046}]}]',
                  price: 3520000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.pizza_roast_beef_ingredients",
                      ),
                      icon: "mdi-asterisk-circle-outline",
                    },
                    {
                      icon: "mdi-asterisk-circle-outline",
                      name: "",
                      value: this.$t(
                        "create_menu.data.product.pizza_roast_beef_ingredients",
                      ),
                    },
                    {
                      icon: "mdi-asterisk-circle-outline",
                      name: "",
                      value: this.$t(
                        "create_menu.data.product.pizza_roast_beef_ingredients",
                      ),
                    },
                    {
                      icon: "mdi-asterisk-circle-outline",
                      name: "",
                      value: this.$t(
                        "create_menu.data.product.pizza_roast_beef_ingredients",
                      ),
                    },
                    {
                      icon: "mdi-asterisk-circle-outline",
                      name: "",
                      value: "salam",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t(
                    "create_menu.data.product.pizza_chicken_mushroom",
                  ),
                  description: this.$t(
                    "create_menu.data.product.pizza_chicken_mushroom_desc",
                  ),
                  discount_amount: 30,
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"پیتزا10","title":"","url":"https://cdn.terminalads.com/upload/65438aec0a2d3.webp","description":"","link":"","id":15048}]}]',
                  price: 5580000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.pizza_chicken_mushroom_ingredients",
                      ),
                      icon: "mdi-arrow-bottom-left-bold-outline",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.pizza_meat_mushroom"),
                  description: this.$t(
                    "create_menu.data.product.pizza_meat_mushroom_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"پیتزا گوشت","title":"","url":"https://cdn.terminalads.com/upload/65684fdf0403c.webp","description":"","link":"","id":15872}]}]',
                  price: 3550000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.pizza_meat_mushroom_ingredients",
                      ),
                      icon: "mdi-arrow-left-bold-circle-outline",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.pizza_veggie"),
                  description: this.$t(
                    "create_menu.data.product.pizza_veggie_desc",
                  ),
                  discount_amount: 10,
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"پیتزا سبزیجات","title":"","url":"https://cdn.terminalads.com/upload/65685889708e0.webp","description":"","link":"","id":15873}]}]',
                  price: 3200000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.pizza_veggie_ingredients",
                      ),
                      icon: "mdi-asterisk",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.pizza_special"),
                  description: this.$t(
                    "create_menu.data.product.pizza_special_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"پیتزا4","title":"","url":"https://cdn.terminalads.com/upload/65438ae232e76.webp","description":"","link":"","id":15042}]}]',
                  price: 2860000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.pizza_special_ingredients",
                      ),
                      icon: "mdi-asterisk-circle-outline",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.pizza_bolognese"),
                  description: this.$t(
                    "create_menu.data.product.pizza_bolognese_desc",
                  ),
                  discount_amount: 10,
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"پیتزا بولنیز","title":"","url":"https://cdn.terminalads.com/upload/6641b8b6e5c7f.webp","description":"","link":"","id":16922}]}]',
                  price: 3700000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.pizza_bolognese_ingredients",
                      ),
                      icon: "mdi-pizza",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.pizza_pepperoni"),
                  description: this.$t(
                    "create_menu.data.product.pizza_pepperoni_desc",
                  ),
                  discount_amount: 10,
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"پیتزا پپرونی ","title":"","url":"https://cdn.terminalads.com/upload/6641c51b1d0d1.webp","description":"","link":"","id":16940}]}]',
                  price: 2380000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.pizza_pepperoni_ingredients",
                      ),
                      icon: "mdi-pizza",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.pizza_bacon"),
                  description: this.$t(
                    "create_menu.data.product.pizza_bacon_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"پیتزا بیکن ","title":"","url":"https://cdn.terminalads.com/upload/6641c897904c0.webp","description":"","link":"","id":16941}]}]',
                  price: 2330000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.pizza_bacon_ingredients",
                      ),
                      icon: "mdi-pizza",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.pizza_mixed"),
                  description: this.$t(
                    "create_menu.data.product.pizza_mixed_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"پیترا مخلوط","title":"","url":"https://cdn.terminalads.com/upload/6641ce20a9d11.webp","description":"","link":"","id":16942}]}]',
                  price: 2360000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.pizza_mixed_ingredients",
                      ),
                      icon: "mdi-pizza",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t(
                    "create_menu.data.product.pizza_american_steak",
                  ),
                  description: this.$t(
                    "create_menu.data.product.pizza_american_steak_desc",
                  ),
                  discount_amount: 10,
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"پچیتزا استیک","title":"","url":"https://cdn.terminalads.com/upload/6641d2e39f379.webp","description":"","link":"","id":16943}]}]',
                  price: 3430000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.pizza_american_steak_ingredients",
                      ),
                      icon: "mdi-pizza",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
              ],
            },

            {
              name: this.$t("create_menu.data.product.burgers"),
              picture: this.$cdnUrl + "/upload/65438b4d7fcb5.webp",
              children: [],
              status: "active",
              source_id: null,
              products: [
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.cheeseburger"),
                  description: this.$t(
                    "create_menu.data.product.cheeseburger_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"چیزبرگر2","title":"","url":"https://cdn.terminalads.com/upload/65438bb325703.webp","description":"","link":"","id":15060}]}]',
                  price: 2650000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.cheeseburger_ingredients",
                      ),
                      icon: "mdi-check-underline-circle-outline",
                    },
                    {
                      icon: "mdi-check-underline-circle-outline",
                      name: "",
                      value: this.$t(
                        "create_menu.data.product.cheeseburger_ingredients",
                      ),
                    },
                    {
                      icon: "mdi-check-underline-circle-outline",
                      name: "",
                      value: this.$t(
                        "create_menu.data.product.cheeseburger_ingredients",
                      ),
                    },
                    {
                      icon: "mdi-check-underline-circle-outline",
                      name: "",
                      value: this.$t(
                        "create_menu.data.product.cheeseburger_ingredients",
                      ),
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.hamburger"),
                  description: this.$t(
                    "create_menu.data.product.hamburger_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"همبرگر8","title":"","url":"https://cdn.terminalads.com/upload/65438b4f36a6d.webp","description":"","link":"","id":15056}]}]',
                  price: 1600000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.hamburger_ingredients",
                      ),
                      icon: "mdi-bell-check-outline",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.chicken_burger"),
                  description: this.$t(
                    "create_menu.data.product.chicken_burger_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"چیکن برگر3","title":"","url":"https://cdn.terminalads.com/upload/65438beaa3a98.webp","description":"","link":"","id":15071}]}]',
                  price: 1750000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.chicken_burger_ingredients",
                      ),
                      icon: "mdi-bell-ring",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.spice_burger"),
                  description: this.$t(
                    "create_menu.data.product.spice_burger_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"اسپایسی برگر3","title":"","url":"https://cdn.terminalads.com/upload/65438c2f65683.webp","description":"","link":"","id":15081}]}]',
                  price: 175000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.spice_burger_ingredients",
                      ),
                      icon: "mdi-book-alert-outline",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.double_burger"),
                  description: this.$t(
                    "create_menu.data.product.double_burger_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"دوبل برگر","title":"","url":"https://cdn.terminalads.com/upload/6641d4a7294fc.webp","description":"","link":"","id":16944}]}]',
                  price: 2790000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.double_burger_ingredients",
                      ),
                      icon: "mdi-hamburger",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.royal_burger"),
                  description: this.$t(
                    "create_menu.data.product.royal_burger_desc",
                  ),
                  discount_amount: 10,
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"رویال برگر","title":"","url":"https://cdn.terminalads.com/upload/6641ddd9622d2.webp","description":"","link":"","id":16946}]}]',
                  price: 2100000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.royal_burger_ingredients",
                      ),
                      icon: "mdi-hamburger-check",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.mushroom_burger"),
                  description: this.$t(
                    "create_menu.data.product.mushroom_burger_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"قارچ برگر","title":"","url":"https://cdn.terminalads.com/upload/6641ded42d10f.webp","description":"","link":"","id":16947}]}]',
                  price: 1950000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.mushroom_burger_ingredients",
                      ),
                      icon: "mdi-hamburger-plus",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.mashroom_burger"),
                  description: this.$t(
                    "create_menu.data.product.mashroom_burger_desc",
                  ),
                  discount_amount: 10,
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"ماشروم برگر","title":"","url":"https://cdn.terminalads.com/upload/6641e231dbc91.webp","description":"","link":"","id":16948}]}]',
                  price: 2050000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.mashroom_burger_ingredients",
                      ),
                      icon: "mdi-hamburger",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.fried_burger"),
                  description: this.$t(
                    "create_menu.data.product.fried_burger_desc",
                  ),
                  discount_amount: 10,
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"برگر سوخاری","title":"","url":"https://cdn.terminalads.com/upload/6641e27426aaf.webp","description":"","link":"","id":16949}]}]',
                  price: 2020000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.fried_burger_ingredients",
                      ),
                      icon: "mdi-hamburger-check",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
              ],
            },
            {
              name: this.$t("create_menu.data.product.fried"),
              picture: this.$cdnUrl + "/upload/65438c6727fe6.webp",
              children: [],
              status: "active",
              source_id: null,
              products: [
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.fried_chicken"),
                  description: this.$t(
                    "create_menu.data.product.fried_chicken_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"مرغ سوخاری5","title":"","url":"https://cdn.terminalads.com/upload/65438c6a5cc3d.webp","description":"","link":"","id":15093}]}]',
                  price: 2430000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.fried_chicken_ingredients",
                      ),
                      icon: "mdi-check-underline-circle-outline",
                    },
                    {
                      icon: "mdi-check-underline-circle-outline",
                      name: "",
                      value: this.$t(
                        "create_menu.data.product.fried_chicken_ingredients",
                      ),
                    },
                    {
                      icon: "mdi-check-underline-circle-outline",
                      name: "",
                      value: this.$t(
                        "create_menu.data.product.fried_chicken_ingredients",
                      ),
                    },
                    {
                      icon: "mdi-check-underline-circle-outline",
                      name: "",
                      value: this.$t(
                        "create_menu.data.product.fried_chicken_ingredients",
                      ),
                    },
                    {
                      icon: "mdi-check-underline-circle-outline",
                      name: "",
                      value: this.$t(
                        "create_menu.data.product.fried_chicken_ingredients",
                      ),
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.chicken_strips"),
                  description: this.$t(
                    "create_menu.data.product.chicken_strips_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"چیکن استریپس2","title":"","url":"https://cdn.terminalads.com/upload/65438cabcf88d.webp","description":"","link":"","id":15100}]}]',
                  price: 2180000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.chicken_strips_ingredients",
                      ),
                      icon: "mdi-box-cutter",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.fried_filet"),
                  description: this.$t(
                    "create_menu.data.product.fried_filet_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"فیله سوخاری7","title":"","url":"https://cdn.terminalads.com/upload/65438ce095ebe.webp","description":"","link":"","id":15115}]}]',
                  price: 1350000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.fried_filet_ingredients",
                      ),
                      icon: "mdi-check-outline",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t(
                    "create_menu.data.product.fried_mushroom_onion",
                  ),
                  description: this.$t(
                    "create_menu.data.product.fried_mushroom_onion_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"قارچ و پیاز سوخاری1","title":"","url":"https://cdn.terminalads.com/upload/65438d3890308.webp","description":"","link":"","id":15119}]}]',
                  price: 950000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.fried_mushroom_onion_ingredients",
                      ),
                      icon: "mdi-check-outline",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.fried_wings"),
                  description: this.$t(
                    "create_menu.data.product.fried_wings_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"بال سوخاری","title":"","url":"https://cdn.terminalads.com/upload/6641e787c5894.webp","description":"","link":"","id":16957}]}]',
                  price: 1350000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.fried_wings_ingredients",
                      ),
                      icon: "mdi-food-drumstick-outline",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t(
                    "create_menu.data.product.fried_chicken_basket",
                  ),
                  description: this.$t(
                    "create_menu.data.product.fried_chicken_basket_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"سبد مرغ سوخاری ","title":"","url":"https://cdn.terminalads.com/upload/6641e956db7c5.webp","description":"","link":"","id":16994}]}]',
                  price: 4350000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.fried_chicken_basket_ingredients",
                      ),
                      icon: "mdi-food-drumstick",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.fried_schnitzel"),
                  description: this.$t(
                    "create_menu.data.product.fried_schnitzel_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"شینسل مرغ سوخاری نرمال","title":"","url":"https://cdn.terminalads.com/upload/6641ee2178914.webp","description":"","link":"","id":17013}]}]',
                  price: 1950000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.fried_schnitzel_ingredients",
                      ),
                      icon: "mdi-food-drumstick-outline",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.veggie_basket_fried"),
                  description: this.$t(
                    "create_menu.data.product.veggie_basket_fried_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"وجی بسکت سوخاری ","title":"","url":"https://cdn.terminalads.com/upload/6641eed6383c4.webp","description":"","link":"","id":17014}]}]',
                  price: 1400000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.veggie_basket_fried_ingredients",
                      ),
                      icon: "mdi-food-drumstick",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t(
                    "create_menu.data.product.fried_chicken_2_piece",
                  ),
                  description: this.$t(
                    "create_menu.data.product.fried_chicken_2_piece_desc",
                  ),
                  discount_amount: 10,
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"مرغ سوخاری 2 تیکه","title":"","url":"https://cdn.terminalads.com/upload/6641ef8133583.webp","description":"","link":"","id":17015}]}]',
                  price: 2350000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.fried_chicken_2_piece_ingredients",
                      ),
                      icon: "mdi-food-drumstick",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t(
                    "create_menu.data.product.fried_chicken_5_piece",
                  ),
                  description: this.$t(
                    "create_menu.data.product.fried_chicken_5_piece_desc",
                  ),
                  discount_amount: 10,
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"مرغ سوخاری 5 تیکه","title":"","url":"https://cdn.terminalads.com/upload/6641f0465eb46.webp","description":"","link":"","id":17016}]}]',
                  price: 4150000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.fried_chicken_5_piece_ingredients",
                      ),
                      icon: "mdi-food-drumstick-outline",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t(
                    "create_menu.data.product.fried_chicken_7_piece",
                  ),
                  description: this.$t(
                    "create_menu.data.product.fried_chicken_7_piece_desc",
                  ),
                  discount_amount: 5,
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"مرغ سوخاری 7 تیکه","title":"","url":"https://cdn.terminalads.com/upload/6641f0f1c57b3.webp","description":"","link":"","id":17017}]}]',
                  price: 5000000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.fried_chicken_7_piece_ingredients",
                      ),
                      icon: "mdi-food-drumstick-off",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
              ],
            },
            {
              name: this.$t("create_menu.data.product.sandwich"),
              picture: this.$cdnUrl + "/upload/65438dcfc7587.webp",
              children: [],
              status: "active",
              source_id: null,
              products: [
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.hotdog_sandwich"),
                  description: this.$t(
                    "create_menu.data.product.hotdog_sandwich_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"ساندویچ هات داگ 8","title":"","url":"https://cdn.terminalads.com/upload/65438dcc385c5.webp","description":"","link":"","id":15143}]}]',
                  price: 1690000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.hotdog_sandwich_ingredients",
                      ),
                      icon: "mdi-asterisk",
                    },
                    {
                      icon: "mdi-asterisk",
                      name: "",
                      value: this.$t(
                        "create_menu.data.product.hotdog_sandwich_ingredients",
                      ),
                    },
                    {
                      icon: "mdi-asterisk",
                      name: "",
                      value: this.$t(
                        "create_menu.data.product.hotdog_sandwich_ingredients",
                      ),
                    },
                    {
                      icon: "mdi-asterisk",
                      name: "",
                      value: this.$t(
                        "create_menu.data.product.hotdog_sandwich_ingredients",
                      ),
                    },
                    {
                      icon: "mdi-asterisk",
                      name: "",
                      value: "salam",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.roast_beef_sandwich"),
                  description: this.$t(
                    "create_menu.data.product.roast_beef_sandwich_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"ساندویچ رست بیف 3","title":"","url":"https://cdn.terminalads.com/upload/65438df9d0751.webp","description":"","link":"","id":15151}]}]',
                  price: 2050000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.roast_beef_sandwich_ingredients",
                      ),
                      icon: "mdi-check-bold",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.ham_sandwich"),
                  description: this.$t(
                    "create_menu.data.product.ham_sandwich_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"ساندویچ ژامبون 4","title":"","url":"https://cdn.terminalads.com/upload/65438e78d5041.webp","description":"","link":"","id":15164}]}]',
                  price: 930000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.ham_sandwich_ingredients",
                      ),
                      icon: "mdi-check-bold",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t(
                    "create_menu.data.product.bandari_sausage_sandwich",
                  ),
                  description: this.$t(
                    "create_menu.data.product.bandari_sausage_sandwich_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"ساندویج","title":"","url":"https://cdn.terminalads.com/upload/6568640e8720d.webp","description":"","link":"","id":15884}]}]',
                  price: 1070000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.bandari_sausage_sandwich_ingredients",
                      ),
                      icon: "mdi-arrow-down-drop-circle",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t(
                    "create_menu.data.product.tongue_mushroom_sandwich",
                  ),
                  description: this.$t(
                    "create_menu.data.product.tongue_mushroom_sandwich_desc",
                  ),
                  discount_amount: 5,
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"ساندویچ زبان و قارچ","title":"","url":"https://cdn.terminalads.com/upload/6641f83911b2a.webp","description":"","link":"","id":17018}]}]',
                  price: 2550000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.tongue_mushroom_sandwich_ingredients",
                      ),
                      icon: "mdi-food-hot-dog",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.falafel_sandwich"),
                  description: this.$t(
                    "create_menu.data.product.falafel_sandwich_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"ساندویچ فلافل","title":"","url":"https://cdn.terminalads.com/upload/6641fa00162db.webp","description":"","link":"","id":17019}]}]',
                  price: 7500000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.falafel_sandwich_ingredients",
                      ),
                      icon: "mdi-food-hot-dog",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t(
                    "create_menu.data.product.cheesy_kebab_turki_sandwich",
                  ),
                  description: this.$t(
                    "create_menu.data.product.cheesy_kebab_turki_sandwich_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"ساندویچ کباب ترکی","title":"","url":"https://cdn.terminalads.com/upload/6641fadc02946.webp","description":"","link":"","id":17020}]}]',
                  price: 1700000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.cheesy_kebab_turki_sandwich_ingredients",
                      ),
                      icon: "mdi-food-hot-dog",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t(
                    "create_menu.data.product.roast_chicken_sandwich",
                  ),
                  description: this.$t(
                    "create_menu.data.product.roast_chicken_sandwich_desc",
                  ),
                  discount_amount: 10,
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"ساندویچ مرغ","title":"","url":"https://cdn.terminalads.com/upload/6641fc0693095.webp","description":"","link":"","id":17021}]}]',
                  price: 1750000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.roast_chicken_sandwich_ingredients",
                      ),
                      icon: "mdi-food-outline",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t(
                    "create_menu.data.product.cheesy_indian_sandwich",
                  ),
                  description: this.$t(
                    "create_menu.data.product.cheesy_indian_sandwich_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"ساندویچ هندی پنیری","title":"","url":"https://cdn.terminalads.com/upload/6641fd19b374f.webp","description":"","link":"","id":17022}]}]',
                  price: 1300000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.cheesy_indian_sandwich_ingredients",
                      ),
                      icon: "mdi-food-hot-dog",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
              ],
            },
            {
              name: this.$t("create_menu.data.product.snack"),
              picture: this.$cdnUrl + "/upload/65438d8868438.webp",
              children: [],
              status: "active",
              source_id: null,
              products: [
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.chicken_snack"),
                  description: this.$t(
                    "create_menu.data.product.chicken_snack_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"اسنک10","title":"","url":"https://cdn.terminalads.com/upload/65438d916e82f.webp","description":"","link":"","id":15138}]}]',
                  price: 840000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.chicken_snack_ingredients",
                      ),
                      icon: "mdi-bell-check",
                    },
                    {
                      icon: "mdi-bell-check",
                      name: "",
                      value: this.$t(
                        "create_menu.data.product.chicken_snack_ingredients",
                      ),
                    },
                    {
                      icon: "mdi-bell-check",
                      name: "",
                      value: this.$t(
                        "create_menu.data.product.chicken_snack_ingredients",
                      ),
                    },
                    {
                      icon: "mdi-bell-check",
                      name: "",
                      value: this.$t(
                        "create_menu.data.product.chicken_snack_ingredients",
                      ),
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.meat_snack"),
                  description: this.$t(
                    "create_menu.data.product.meat_snack_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"اسنک گوشت","title":"","url":"https://cdn.terminalads.com/upload/657024a0a5e1f.webp","description":"","link":"","id":15985}]}]',
                  price: 890000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.meat_snack_ingredients",
                      ),
                      icon: "mdi-arrow-left-drop-circle",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.chicken_meat_snack"),
                  description: this.$t(
                    "create_menu.data.product.chicken_meat_snack_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"فست فود 128","title":"","url":"https://cdn.terminalads.com/upload/657027ee2158b.webp","description":"","link":"","id":15989}]}]',
                  price: 850000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.chicken_meat_snack_ingredients",
                      ),
                      icon: "mdi-bowl",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.special_snack"),
                  description: this.$t(
                    "create_menu.data.product.special_snack_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"اسنک پپرونی","title":"","url":"https://cdn.terminalads.com/upload/65702e2186f43.webp","description":"","link":"","id":15992}]}]',
                  price: 690000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.special_snack_ingredients",
                      ),
                      icon: "mdi-asterisk",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.roast_beef_snack"),
                  description: this.$t(
                    "create_menu.data.product.roast_beef_snack_desc",
                  ),
                  discount_amount: 6,
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"اسنک رست بیف","title":"","url":"https://cdn.terminalads.com/upload/664200d531170.webp","description":"","link":"","id":17023}]}]',
                  price: 2450000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.roast_beef_snack_ingredients",
                      ),
                      icon: "mdi-food",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.veggie_snack"),
                  description: this.$t(
                    "create_menu.data.product.veggie_snack_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"اسنک سبزیجات","title":"","url":"https://cdn.terminalads.com/upload/664201be2e5c9.webp","description":"","link":"","id":17024}]}]',
                  price: 1650000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.veggie_snack_ingredients",
                      ),
                      icon: "mdi-food-outline",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t(
                    "create_menu.data.product.chicken_mushroom_snack",
                  ),
                  description: this.$t(
                    "create_menu.data.product.chicken_mushroom_snack_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"اسنک مرغ وقارچ","title":"","url":"https://cdn.terminalads.com/upload/664202633b06f.webp","description":"","link":"","id":17025}]}]',
                  price: 2050000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.chicken_mushroom_snack_ingredients",
                      ),
                      icon: "mdi-food-hot-dog",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.pepperoni_snack"),
                  description: this.$t(
                    "create_menu.data.product.pepperoni_snack_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"اسنک پپرونی","title":"","url":"https://cdn.terminalads.com/upload/66420581bd658.webp","description":"","link":"","id":17026}]}]',
                  price: 799000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.pepperoni_snack_ingredients",
                      ),
                      icon: "mdi-food-fork-drink",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.bologna_snack"),
                  description: this.$t(
                    "create_menu.data.product.bologna_snack_desc",
                  ),
                  discount_amount: 5,
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"اسنک بلونیا","title":"","url":"https://cdn.terminalads.com/upload/664208452f49f.webp","description":"","link":"","id":17027}]}]',
                  price: 990000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.bologna_snack_ingredients",
                      ),
                      icon: "mdi-food",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
              ],
            },
            {
              name: this.$t("create_menu.data.product.pasta"),
              picture: this.$cdnUrl + "/upload/65438ea783805.webp",
              children: [],
              status: "active",
              source_id: null,
              products: [
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.alfredo_pasta"),
                  description: this.$t(
                    "create_menu.data.product.alfredo_pasta_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"پاستا آفردو 2","title":"","url":"https://cdn.terminalads.com/upload/65438e9a9b839.webp","description":"","link":"","id":15170}]}]',
                  price: 230000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.alfredo_pasta_ingredients",
                      ),
                      icon: "mdi-asterisk-circle-outline",
                    },
                    {
                      icon: "mdi-asterisk-circle-outline",
                      name: "",
                      value: "salam",
                    },
                    {
                      icon: "mdi-asterisk-circle-outline",
                      name: "",
                      value: "salam",
                    },
                    {
                      icon: "mdi-asterisk-circle-outline",
                      name: "",
                      value: "salam",
                    },
                    {
                      icon: "mdi-asterisk-circle-outline",
                      name: "",
                      value: "salam",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.macaroni"),
                  description: this.$t(
                    "create_menu.data.product.macaroni_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"ماکارانی","title":"","url":"https://cdn.terminalads.com/upload/657040074f8e5.webp","description":"","link":"","id":15997}]}]',
                  price: 1330000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.macaroni_ingredients",
                      ),
                      icon: "mdi-arrow-left-bold",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.spaghetti_bolognese"),
                  description: this.$t(
                    "create_menu.data.product.spaghetti_bolognese_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"_اسپاگتی بلونز","title":"","url":"https://cdn.terminalads.com/upload/6570458726c29.webp","description":"","link":"","id":16000}]}]',
                  price: 2120000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.spaghetti_bolognese_ingredients",
                      ),
                      icon: "mdi-arrow-left-drop-circle",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.chicken_stroganoff"),
                  description: this.$t(
                    "create_menu.data.product.chicken_stroganoff_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"چیکن استراگانف","title":"","url":"https://cdn.terminalads.com/upload/65704943d2754.webp","description":"","link":"","id":16004}]}]',
                  price: 2520000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.chicken_stroganoff_ingredients",
                      ),
                      icon: "mdi-arrow-u-left-top",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.penne_arabiata"),
                  description: this.$t(
                    "create_menu.data.product.penne_arabiata_desc",
                  ),
                  discount_amount: 10,
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"پاستا پنه آرابیاتا","title":"","url":"https://cdn.terminalads.com/upload/66420fb60b7d0.webp","description":"","link":"","id":17028}]}]',
                  price: 1900000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.penne_arabiata_ingredients",
                      ),
                      icon: "mdi-car-defrost-front",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.chicken_pesto_pasta"),
                  description: this.$t(
                    "create_menu.data.product.chicken_pesto_pasta_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"پاستا چیکن پستو","title":"","url":"https://cdn.terminalads.com/upload/664210eeeca10.webp","description":"","link":"","id":17029}]}]',
                  price: 1900000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.chicken_pesto_pasta_ingredients",
                      ),
                      icon: "mdi-bowl-mix",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.carbonara_pasta"),
                  description: this.$t(
                    "create_menu.data.product.carbonara_pasta_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"پاستا کاربونارا","title":"","url":"https://cdn.terminalads.com/upload/6642145947c23.webp","description":"","link":"","id":17030}]}]',
                  price: 2080000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.carbonara_pasta_ingredients",
                      ),
                      icon: "mdi-food-takeout-box",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
              ],
            },
            {
              name: this.$t("create_menu.data.product.appetizer"),
              picture: this.$cdnUrl + "/upload/65438f225e92e.webp",
              children: [],
              status: "active",
              source_id: null,
              products: [
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.hot_chips"),
                  description: this.$t(
                    "create_menu.data.product.hot_chips_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"هات چیپس1","title":"","url":"https://cdn.terminalads.com/upload/65438f1bb00ce.webp","description":"","link":"","id":15199}]}]',
                  price: 3890000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.hot_chips_ingredients",
                      ),
                      icon: "mdi-asterisk-circle-outline",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.lasagna"),
                  description: this.$t("create_menu.data.product.lasagna_desc"),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"لازانیا2","title":"","url":"https://cdn.terminalads.com/upload/65438efc0c5bd.webp","description":"","link":"","id":15190}]}]',
                  price: 400000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.lasagna_ingredients",
                      ),
                      icon: "mdi-asterisk-circle-outline",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.french_fries"),
                  description: this.$t(
                    "create_menu.data.product.french_fries_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"سیب زمینی 4","title":"","url":"https://cdn.terminalads.com/upload/65438f56d1fef.webp","description":"","link":"","id":15211}]}]',
                  price: 890000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.french_fries_ingredients",
                      ),
                      icon: "mdi-bell",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.baked_potato"),
                  description: this.$t(
                    "create_menu.data.product.baked_potato_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"","images":[{"name":"سیب زمینی تنوری ","title":"","url":"https://cdn.terminalads.com/upload/65704e248cfae.webp","description":"","link":"","id":16008}]}]',
                  price: 1490000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.baked_potato_ingredients",
                      ),
                      icon: "mdi-check-all",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.garlic_bread"),
                  description: this.$t(
                    "create_menu.data.product.garlic_bread_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"نان سیر","title":"","url":"https://cdn.terminalads.com/upload/664218cc28186.webp","description":"","link":"","id":17031}]}]',
                  price: 900000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.garlic_bread_ingredients",
                      ),
                      icon: "mdi-food-outline",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.silo_potatoes"),
                  description: this.$t(
                    "create_menu.data.product.silo_potatoes_desc",
                  ),
                  discount_amount: 5,
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"سیب زمینی سیلو","title":"","url":"https://cdn.terminalads.com/upload/66421c9780fea.webp","description":"","link":"","id":17032}]}]',
                  price: 2820000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.silo_potatoes_ingredients",
                      ),
                      icon: "mdi-food",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.bbq_sausage"),
                  description: this.$t(
                    "create_menu.data.product.bbq_sausage_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"سوسیس باربیکیو","title":"","url":"https://cdn.terminalads.com/upload/66421e3333415.webp","description":"","link":"","id":17033}]}]',
                  price: 500000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.bbq_sausage_ingredients",
                      ),
                      icon: "mdi-food-fork-drink",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.silo_toast"),
                  description: this.$t(
                    "create_menu.data.product.silo_toast_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"تست سیلو","title":"","url":"https://cdn.terminalads.com/upload/6642208c08f1a.webp","description":"","link":"","id":17034}]}]',
                  price: 3640000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.silo_toast_ingredients",
                      ),
                      icon: "mdi-arrow-left-thin",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
              ],
            },
            {
              name: this.$t("create_menu.data.product.salad_and_dessert"),
              picture: this.$cdnUrl + "/upload/66461c34971f6.webp",
              children: [],
              status: "active",
              source_id: null,
              products: [
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.caesar_salad"),
                  description: this.$t(
                    "create_menu.data.product.caesar_salad_desc",
                  ),
                  discount_amount: 5,
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"سالادسزار","title":"","url":"https://cdn.terminalads.com/upload/66461c71cb470.webp","description":"","link":"","id":17088}]}]',
                  price: 1610000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.caesar_salad_ingredients",
                      ),
                      icon: "mdi-bowl-mix",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  braind: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.coleslaw_salad"),
                  description: this.$t(
                    "create_menu.data.product.coleslaw_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"سالاد کلم","title":"","url":"https://cdn.terminalads.com/upload/66461cf43532e.webp","description":"","link":"","id":17089}]}]',
                  price: 200000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.coleslaw_salad_ingredients",
                      ),
                      icon: "mdi-bowl-mix",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.macaroni_salad"),
                  description: this.$t(
                    "create_menu.data.product.macaroni_salad_desc",
                  ),
                  discount_amount: 10,
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"سالاد ماکارانی","title":"","url":"https://cdn.terminalads.com/upload/66461edbd3d3d.webp","description":"","link":"","id":17093}]}]',
                  price: 550000,
                  extra: [
                    {
                      label: "",
                      value: "",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.pachira_salad"),
                  description: this.$t(
                    "create_menu.data.product.pachira_salad_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"سالاد پاچیرا","title":"","url":"https://cdn.terminalads.com/upload/66461df229901.webp","description":"","link":"","id":17091}]}]',
                  price: 320000,
                  extra: [
                    {
                      label: "",
                      value: this.$t(
                        "create_menu.data.product.pachira_salad_ingredients",
                      ),
                      icon: "mdi-bowl-mix",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
              ],
            },
            {
              name: this.$t("create_menu.data.product.beverages"),
              picture: this.$cdnUrl + "/upload/6648b0aab3cf9.webp",
              children: [],
              status: "active",
              source_id: null,
              products: [
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.local_yogurt_drink"),
                  description: this.$t(
                    "create_menu.data.product.local_yogurt_drink_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"دوغ","title":"","url":"https://cdn.terminalads.com/upload/6648b14c756f0.webp","description":"","link":"","id":17111}]}]',
                  price: 450000,
                  extra: [
                    {
                      label: "",
                      value: "",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.black_soda"),
                  description: this.$t(
                    "create_menu.data.product.black_soda_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"نوشابه مشکی","title":"","url":"https://cdn.terminalads.com/upload/664aeb7548481.webp","description":"","link":"","id":17141}]}]',
                  price: 290000,
                  extra: [
                    {
                      label: "",
                      value: "",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.fanta"),
                  description: this.$t("create_menu.data.product.fanta_desc"),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"نوشابه زرد","title":"","url":"https://cdn.terminalads.com/upload/664aec4a519a0.webp","description":"","link":"","id":17142}]}]',
                  price: 290000,
                  extra: [
                    {
                      label: "",
                      value: "",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t("create_menu.data.product.mojito"),
                  description: this.$t("create_menu.data.product.mojito_desc"),
                  discount_amount: 10,
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"موهیتو","title":"","url":"https://cdn.terminalads.com/upload/664aecd55b31c.webp","description":"","link":"","id":17143}]}]',
                  price: 450000,
                  extra: [
                    {
                      label: "",
                      value: "",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
                {
                  status: "active",
                  name: this.$t(
                    "create_menu.data.product.tropical_malt_beverage",
                  ),
                  description: this.$t(
                    "create_menu.data.product.tropical_malt_beverage_desc",
                  ),
                  discount_amount: "",
                  discount_type: "percent",
                  gallery:
                    '[{"name":"گالری عکس","images":[{"name":"دلستر","title":"","url":"https://cdn.terminalads.com/upload/664aedb43f80a.webp","description":"","link":"","id":17144}]}]',
                  price: 0,
                  extra: [
                    {
                      label: "",
                      value: "",
                    },
                  ],
                  quantity: null,
                  options: [],
                  children: [],
                  default_option: null,
                  packing_price: 0,
                  order_limit: null,
                  inventory: null,
                  brand: "",
                  parent_id: null,
                },
              ],
            },
          ],
          onlineShop: true,
        },
        textCards: {
          sectionColor: {
            backGround: "linear-gradient(to bottom , #007376FF, #08004AFF)",
            text: "#fff",
          },
        },
        extraFields: [
          {
            icon: "",
            name: "",
            value: "",
          },
        ],
        socialMedia: {
          address: [
            {
              label: this.$t("create_menu.data.socialMedia.address_label"),
              text: this.$t("create_menu.data.socialMedia.address_text"),
              pattern: "",
              prefix: "URL",
              url: "qrland.ir",
              img: "/media/socialIcon/40icon/location.svg",
              svg: "svgLocation",
            },
            {
              label: this.$t("create_menu.data.socialMedia.address_label"),
              text: this.$t("create_menu.data.socialMedia.address_text"),
              pattern: "",
              prefix: "URL",
              url: "qr.terminalads.com",
              img: "/media/socialIcon/40icon/location.svg",
              svg: "svgLocation",
            },
          ],
          instagram: [
            {
              label: this.$t("create_menu.data.socialMedia.instagram_label"),
              text: this.$t("create_menu.data.socialMedia.instagram_text"),
              pattern: "https://instagram.com/",
              prefix: "@",
              url: "terminalads",
              img: "/media/socialIcon/40icon/instagram.svg",
              svg: "svgInstagram",
            },
          ],
          whatsapp: [
            {
              label: this.$t("create_menu.data.socialMedia.whatsapp_label"),
              text: this.$t("create_menu.data.socialMedia.whatsapp_text"),
              pattern: "wa.me/",
              prefix: "mdi-phone",
              url: "+982191017077",
              img: "/media/socialIcon/40icon/whatsapp.svg",
              svg: "svgWhatsapp",
            },
          ],
        },
        PicSelector: {
          title: null,
          description: null,
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: true,
        },
        gallery: [
          {
            name: this.$t("create_menu.data.gallery.gallery_0"),
            images: [
              {
                name: this.$t("create_menu.data.gallery.image_2"),
                title: "",
                url: this.$cdnUrl + "/upload/6568616ca633b.webp",
                description: "",
                link: "",
                id: 15880,
              },
              {
                name: this.$t("create_menu.data.gallery.image_3"),
                title: "",
                url: this.$cdnUrl + "/upload/656861707f28e.webp",
                description: "",
                link: "",
                id: 15881,
              },
              {
                name: this.$t("create_menu.data.gallery.image_1"),
                title: "",
                url: this.$cdnUrl + "/upload/656861694988e.webp",
                description: "",
                link: "",
                id: 15879,
              },
              {
                name: this.$t("create_menu.data.gallery.image_5"),
                title: "",
                url: this.$cdnUrl + "/upload/656861777120d.webp",
                description: "",
                link: "",
                id: 15883,
              },
              {
                name: this.$t("create_menu.data.gallery.image_4"),
                title: "",
                url: this.$cdnUrl + "/upload/65686173e171a.webp",
                description: "",
                link: "",
                id: 15882,
              },
              {
                name: this.$t("create_menu.data.gallery.baked_potato_2"),
                title: "",
                url: this.$cdnUrl + "/upload/65704e3a58806.webp",
                description: "",
                link: "",
                id: 16009,
              },
              {
                name: this.$t("create_menu.data.gallery.chicken_stroganoff_1"),
                title: "",
                url: this.$cdnUrl + "/upload/65704b428cb1d.webp",
                description: "",
                link: "",
                id: 16005,
              },
            ],
          },
        ],
        VideoGallery: {
          title: this.$t("create_menu.data.videoGallery.title"),
          description: this.$t("create_menu.data.videoGallery.description"),
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        video_gallery: [
          {
            name: this.$t("create_menu.data.videoGallery.tutorial"),
            images: [
              {
                title: this.$t("create_menu.data.videoGallery.fast_food"),
                file_link:
                  "https://www.aparat.com/video/video/embed/videohash/dsgFq/vt/frame",
                description: "",
                link: "",
              },
            ],
          },
        ],
        FeedBack: {
          title: this.$t("create_menu.data.feedback.title"),
          description: this.$t("create_menu.data.feedback.description"),
          sectionColor: {
            backGround: "linear-gradient(to right , #FFFFFFFF, #FFFFFFFF)",
            text: "",
          },
          type: "text",
          items: [
            {
              question: this.$t("create_menu.data.feedback.question1"),
              type: "star",
              answer: "",
              value: null,
              description: false,
              forceDesc: false,
            },
            {
              question: this.$t("create_menu.data.feedback.question2"),
              type: "star",
              answer: "",
              value: null,
              description: false,
              forceDesc: false,
            },
            {
              question: this.$t("create_menu.data.feedback.question3"),
              type: "star",
              answer: "",
              value: null,
              description: false,
              forceDesc: false,
            },
            {
              question: this.$t("create_menu.data.feedback.question4"),
              type: "star",
              answer: "",
              value: null,
              description: false,
              forceDesc: false,
            },
            {
              question: this.$t("create_menu.data.feedback.question5"),
              type: "star",
              answer: "",
              value: null,
              description: true,
              forceDesc: false,
            },
          ],
        },
        WorkSheet: {
          items: {
            saturday: {
              name: this.$t("create_menu.data.worksheet.saturday"),
              shift: [
                {
                  start: "10:00",
                  end: "22:00",
                },
                {},
              ],
              start: "08:00:00",
              end: "22:00:00",
            },
            sunday: {
              name: this.$t("create_menu.data.worksheet.sunday"),
              shift: [
                {
                  start: "10:00",
                  end: "22:00",
                },
                {},
              ],
              start: "08:00:00",
              end: "22:00:00",
            },
            monday: {
              name: this.$t("create_menu.data.worksheet.monday"),
              shift: [
                {
                  start: "10:00",
                  end: "22:00",
                },
                {},
              ],
              start: "08:00:00",
              end: "22:00:00",
            },
            tuesday: {
              name: this.$t("create_menu.data.worksheet.tuesday"),
              shift: [
                {
                  start: "10:00",
                  end: "22:00",
                },
                {},
              ],
              start: "08:00:00",
              end: "22:00:00",
            },
            wednesday: {
              name: this.$t("create_menu.data.worksheet.wednesday"),
              shift: [
                {
                  start: "10:00",
                  end: "00:00",
                },
                {},
              ],
              start: "08:00:00",
              end: "22:00:00",
            },
            thursday: {
              name: this.$t("create_menu.data.worksheet.thursday"),
              shift: [
                {
                  start: "10:00",
                  end: "00:00",
                },
                {},
              ],
              start: "08:00:00",
              end: "22:00:00",
            },
            friday: {
              name: this.$t("create_menu.data.worksheet.friday"),
              shift: [
                {
                  start: "10:00",
                  end: "00:00",
                },
                {},
              ],
              start: "08:00:00",
              end: "22:00:00",
            },
          },
        },
        
        visitName: "",
        organizationName: this.$t("create_menu.data.organizationName"),
        subOrgan: this.$t("create_menu.data.subOrgan"),
        userName: "",
        workField: "",
        phoneNumber: [
          {
            number: this.$t("create_menu.data.contact.phone_1"),
          },
          {
            number: this.$t("create_menu.data.contact.phone_2"),
          },
          {
            number: this.$t("create_menu.data.contact.phone_3"),
          },
        ],
        companyNumber: this.$t("create_menu.data.contact.company_number"),
        email: this.$t("create_menu.data.contact.email"),
        fax: this.$t("create_menu.data.contact.fax"),
        location: this.$t("create_menu.data.contact.location"),
        city: "",
        codePostal: this.$t("create_menu.data.contact.codePostal"),
        province: "",
        country: "",
        website: this.$t("create_menu.data.contact.website"),
        aboutUs: this.$t("create_menu.data.aboutUs"),
        copyright: this.$t("create_menu.data.copyright"),
        center: [51.44663997885132, 35.74305387731438],
        coordinates: [51.446682645747444, 35.743053507096036],
        address: this.$t("create_menu.data.contact.address_details"),
        pallete: {},
      };
    
        },
    markQr(final = false) {
      if (
        !this.dtUrl ||
        typeof this.$refs["address-field"].dtUrlRule(this.dtUrl) !== "boolean"
      ) {
        this.$toast.clear();
        this.$toast.error("آدرس وارد شده صحیح نمی‌باشد!");
        return;
      }

      this.loading = true;

      let obj = {
        type: "menu",
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        domain_id: this.domainId,
        data: JSON.stringify({
          theme: this.cardTexts?.ThemeSelector2?.theme,
          data: this.cardTexts,
        }),
        qr: JSON.stringify(this.qrDesign),
      };

      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.errors = {};
      this.$api
        .post("/v1/testQr/store", obj)
        .then(({ data }) => {
          this.loading = false;
          this.info = data.data;
          this.createdId = data.data.identifier;

          this.createdDomain = this.$refs["address-field"].destItems.find(
            (item) => item.id === this.domainId,
          ).name;
          this.setCreatedQrID(data.data.id);
          this.updateQrId(data.data.id);
          this.updateQridentifier(data.data.identifier);
          this.setQrType(data.data.type);
          this.updateQrDomain(this.createdDomain);

          this.$toast.success(
            this.$t("create_menu.online_menu_created_successfully"),
          );
          this.qrShow = 0;
          if (this.e6 === 1) {
            this.e6 = 2;
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.qrCanvas.appendCanvas(data.data.link);
              }, 500);
              setTimeout(() => {
                this.qrUpdate(false);
                this.qrShow = 1;
              }, 2000);
            });

            this.$refs.qrShop.handleQrType();
          }
        })
        .catch((error) => {
          const response = error.response;
          if (response.status === 422)
            this.$modal.error("خطا", response.data.message);
          const errorMap = {
            "The آدرس کیوآر has already been taken.": "errors.qr_address_taken",
          };

          const translatedErrors = {};

          if (response?.data?.errors) {
            const backendErrors = response.data.errors;

            Object.entries(backendErrors).forEach(
              ([fieldKey, fieldMessages]) => {
                try {
                  translatedErrors[fieldKey] = fieldMessages.map((msg) => {
                    const key = errorMap[msg];
                    return key ? this.$t(key) : msg;
                  });

                  const msg = fieldMessages[0];
                  const key = errorMap[msg];
                  this.$toast.error(key ? this.$t(key) : msg, {
                    timeout: 3000,
                  });
                } catch (e) {
                  console.log("Error in mapping translation: ", e);
                }
              },
            );

            this.errors = translatedErrors;
          } else {
            this.$toast.error(this.$t("qr_creation_failed"));
          }

          let el = document.getElementById("qr-address");
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      const data = new FormData();
      data.append("type", "menu");
      data.append("image", this.qrSvgDataUrl);
      data.append("qrType", "dynamic");
      data.append("domain", this.createdDomain);
      data.append("identifier", this.createdId || "");
      data.append("qr_id", this.info.qrId);
      data.append("_method", "PUT");
      this.cardTexts.language = getLanguageCookie()
        ? getLanguageCookie()
        : "fa";

      data.append(
        "data",
        JSON.stringify({
          theme: this.cardTexts?.ThemeSelector2?.theme,
          data: this.cardTexts,
        }),
      );
      data.append("qr", JSON.stringify(this.qrDesign));

      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then((res) => {
          if(final || !this.AutoSave)
            this.$toast.success(
              this.$t("create_menu.online_menu_qr_updated_successfully"),
            );
          if (this.e6 === 2 && final) {
            this.e6++;
          }
        })
        .catch((err) => {
          this.$toast.error(this.$t("create_menu.error_saving_updating_qr"));
        })
        .finally(() => {
            this.loading = false;
            this.isAutoSaving = false;
        });
    },
    clearDefaults() {
      let name = this.cardTexts.visitName;
      this.cardTexts = this.getInitialCardTexts();
      this.cardTexts.visitName = name;
    },
    async updateShopSettings() {
      this.loading = true;
      await this.$refs.qrShop
        .setCartSetting()
        .then((data) => {
        })
        .finally(() => {
          this.setTableReservation();
          this.loading = false;
          this.goTo('qr/list')

        });
    },
    setTableReservation() {
      this.$refs.qrShop
        .setTableReservation()
        .finally(() => this.goto("qr/list"));
    },
    savePageTemplate(input) {
      this.templateLoading = true;

      const ssc = new StoreShopContent(this.createQrID);
      ssc
        .storeCategories(input.product.items)
        .then((data) => {
          this.$toast.success(
            this.$t("create_menu.sample_model_categories_saved_successfully"),
          );
          ssc
            .storeProductFromTemplateModel(data.data, input.product.items)
            .then((data) => {
              this.$root.$emit("fetchCategories");
              this.$toast.success(
                this.$t("create_menu.sample_model_products_saved_successfully"),
              );
            })
            .catch((err) => {
              this.$toast.error(
                this.$t("create_menu.error_saving_sample_model_products"),
              );
            });
        })
        .catch((err) => {
          this.$toast.error(
            this.$t("create_menu.error_saving_sample_model_categories"),
          );
        })
        .finally(() => {
          let obj = { ...input };
          obj.product.items = [];
          this.cardTexts = { ...obj };
          this.templateLoading = false;
        });
    },
  },

  beforeDestroy() {
    this.setCreatedQrID(null);
  }
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
@media (min-width: 960px) {

.sticky-preview {
  position: -webkit-sticky;
  position: sticky;
  top: 0px !important; 
  align-self: flex-start;
  height: max-content;
  z-index: 4;
}}
.qr-floating-btn {
  position: absolute;
  top: 14px;
  left: 14px;
  z-index: 20;
  background-color: rgba(255, 255, 255, 0.9) !important;
}

</style>
